export const ErrorGeneric = {
  defaultMsg: '* Ha ocurrido un error, por favor intente de nuevo más tarde.',
};
